import { ProductDetail, QuotedColor } from '@ravago/shared/page-data/models/elements';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Flyout, FlyoutContent, FlyoutHeader } from '@ravago/shared/radiance/components/flyout/components/Flyout/Flyout';
import { useTranslations } from '@ravago/shared/translations/client';

import { ProductFlyoutColorDetails } from '../product-flyout-color-details';
import { ProductFlyoutProductTitle } from '../product-flyout-product-title';

import { QuoteFlyoutQuotation } from './quote-flyout-quotation';

interface Props {
   product: ProductDetail;
   quotedColor: QuotedColor;
   open: boolean;
   quoteDetailRoute: string;
   onFlyoutClose: () => void;
}

export const QuoteFlyout = ({ product, quotedColor, open, quoteDetailRoute, onFlyoutClose }: Props) => {
   const translate = useTranslations();

   return (
      <Flyout open={open} closeOnOutsideClick onFlyoutClose={onFlyoutClose}>
         <FlyoutHeader> {translate('quote-flyout.title')}</FlyoutHeader>
         <FlyoutContent>
            <Box direction="column" gap="md">
               <Box direction="column">
                  <ProductFlyoutProductTitle title={product?.description} />
                  <ProductFlyoutColorDetails
                     colorId={quotedColor.color.id}
                     colorName={quotedColor.color.name}
                     producerColorCode={quotedColor.color.producerColorCode}
                     desiredColor={undefined}
                  />
               </Box>
               <QuoteFlyoutQuotation quotation={quotedColor.quotation} quoteDetailRoute={quoteDetailRoute} />
            </Box>
         </FlyoutContent>
      </Flyout>
   );
};
